<template>
  <div class="form">
    <div class="row">
      <div class="label"><b>I want to receive the report:</b></div>
      <select v-model="frequency">
        <option>Daily</option>
        <option>Weekly</option>
        <option>Monthly</option>
      </select>
    </div>
    <div class="row" v-if="frequency === 'Daily'">
      <div class="label">Every:</div>
      <input type="number" v-model="cron.day" :min="1" :max="31" /> day(s)
    </div>
    <div class="row" v-if="frequency === 'Weekly'">
      <div class="label">On:</div>
      <div
        class="week-btn"
        v-for="week in weekOptions"
        :key="week.value"
        @click="cron.week = week.value"
        :class="{ active: week.value === cron.week }"
      >
        {{ week.label }}
      </div>
    </div>
    <div class="row" v-if="frequency === 'Monthly'">
      <div class="label">Every:</div>
      <input type="number" v-model="cron.month" :min="1" :max="12" /> month(s)
    </div>
    <div class="row" v-if="frequency === 'Monthly'">
      <div class="label">On day:</div>
      <input type="number" v-model="cron.day" :min="1" :max="31" />
    </div>
    <div class="row">
      <div class="label"><b>The report will show data for:</b></div>
      <select v-model="period">
        <option :value="30">30 Days</option>
        <option :value="60">60 Days</option>
      </select>
    </div>
  </div>
</template>

<script>
import Dropdown from '../../../ui/Dropdown';
export default {
  props: ['form'],
  components: {
    Dropdown
  },
  data() {
    return {
      frequency: 'Daily',
      cron: {
        day: 1,
        week: 1,
        month: 1
      },
      period: 30,
      weekOptions: [
        { label: 'Su', value: 0 },
        { label: 'M', value: 1 },
        { label: 'Tu', value: 2 },
        { label: 'W', value: 3 },
        { label: 'Th', value: 4 },
        { label: 'F', value: 5 },
        { label: 'Sa', value: 6 }
      ]
    };
  },
  watch: {
    form: {
      immediate: true,
      handler(val) {
        if (!val) return;
        this.cron = { ...val.cron };
        this.period = val.period;
        this.frequency = val.frequency;
      }
    },
    'cron.day'(val) {
      if (val < 1 || val > 31) {
        this.cron.day = 1;
      }
      this.notifyParent();
    },
    'cron.month'(val) {
      if (val < 1 || val > 12) {
        this.cron.month = 1;
      }
      this.notifyParent();
    },
    'cron.week'(val) {
      this.notifyParent();
    },
    frequency(val) {
      this.notifyParent();
    },
    period(val) {
      this.notifyParent();
    }
  },
  methods: {
    notifyParent() {
      this.$emit('onFormUpdate', {
        frequency: this.frequency,
        period: this.period,
        cron: { ...this.cron }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.form {
  padding: 16px 0;
}
.row {
  margin-bottom: 8px;
  display: flex;
  flex-wrap: wrap;
  margin-right: 0;
  margin-left: 0;
  .label {
    width: 250px;
    text-align: right;
    padding-right: 8px;

    @media screen and (max-width: 440px) {
      font-size: 14px;
    }
  }

  input {
    width: 48px;
    margin-right: 8px;

    @media screen and (max-width: 440px) {
      width: 32px;
    }
  }

  .week-btn {
    width: 32px;
    height: 24px;
    margin: 2px;
    border: 1px solid black;
    text-align: center;
    cursor: pointer;

    &.active {
      background-color: grey;
      border-color: grey;
      color: white;
    }
  }
}
</style>
